import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { buildApiUrl } from "../../config/api";
import { authSuccess } from "../../redux/userRelated/userSlice";
import { isSubscriptionActive } from "../../config/subscriptionPlans";
import { useSubscriptionClock } from "../../hooks/useSubscriptionClock";
import SubscriptionExpiredModal from "./SubscriptionExpiredModal";

/** Wraps admin dashboard — shows payment modal when subscription is not active. */
export default function SubscriptionGate({ children }) {
    const dispatch = useDispatch();
    const { currentUser, currentRole } = useSelector((state) => state.user);
    const isAdmin = currentRole === "Admin" && currentUser;
    useSubscriptionClock(isAdmin ? currentUser : null);
    const blocked = isAdmin && !isSubscriptionActive(currentUser);

    const handleUpdated = useCallback(
        (payload) => {
            const merged = { ...currentUser, ...payload };
            const active =
                payload.subscriptionActive !== undefined
                    ? payload.subscriptionActive
                    : isSubscriptionActive(merged);

            dispatch(
                authSuccess({
                    ...merged,
                    subscriptionActive: active,
                    subscriptionStatus:
                        payload.subscriptionStatus ||
                        (active ? merged.subscriptionStatus : "expired"),
                    subscriptionReason:
                        payload.subscriptionReason ||
                        (active ? merged.subscriptionReason : "trial_expired"),
                }),
            );
        },
        [currentUser, dispatch],
    );

    useEffect(() => {
        if (!isAdmin || !currentUser) return;
        const schoolId = currentUser._id || currentUser.id;
        if (!schoolId) return;
        axios
            .get(buildApiUrl(`/Subscription/${schoolId}`))
            .then((res) => {
                if (res.data) handleUpdated(res.data);
            })
            .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refresh when school id changes only
    }, [isAdmin, currentUser?._id, currentUser?.id]);

    return (
        <>
            {children}
            {isAdmin && (
                <SubscriptionExpiredModal
                    open={blocked}
                    user={currentUser}
                    onSubscriptionUpdated={handleUpdated}
                />
            )}
        </>
    );
}
